import { EventDispatcher, fadeOut, getAgencyImagePath, getNodeIndex, getTimeText, l, last, lc, qs, qsa, range } from '@utils/toolbox';
import { resultsRender } from '@components/resultsRender';
// TODO: move sorting field from class to dataSet

export const timetable = {
	selectedHashes: null,

	sorting: {},

	isInitSortingSet: false,
	elems: {
		timetableElement: qs('#showresult-timetable')
	},
	isActive: false,

	init () {
		if (!js_params?.id) {
			return false;
		}

		this.selectedHashes = new Array(js_params.trips_count);
		this.setupEvents();
	},

	clearHashes () {
		const hashes = this.selectedHashes;

		for (let i = 0; i < hashes.length; i++) {
			hashes[i] = null;
		}
	},

	show () {
		timetable.isActive = true;
	},

	hide () {
		timetable.isActive = false;
	},


	missingAgencyImg (img) {
		img.innerHTML = '<span class="agency-text">' + img.title + '</span>';
	},

	allHashesSet () {
		return timetable.getBounds().every(index => Boolean(timetable.selectedHashes?.[index]));
	},

	update () {
		const groupByMultiple = [];

		for (let i = 0; i < js_params.trips_count; ++i) {
			groupByMultiple.push({ index: i });
		}

		// Ask Showresult to update the results accordingly
		EventDispatcher.dispatch('updateResults', {
			source: 'timetable',
			params: {
				filters: { alternativeHashes: timetable.selectedHashes },
				groupByMultiple: groupByMultiple,
				page: 0
			}
		});
	},

	setupEvents () {
		this.elems.timetableElement.addEventListener('click', (event) => {
			const target = event.target;
			// Select row
			if (target.closest('.timetable-result')) {
				const targetResult = target.closest('.timetable-result');
				const header = targetResult.closest('thead');

				if (header) {
					return;
				}

				const container = targetResult.closest('.table-container');
				const index = getNodeIndex(container);
				const hash = targetResult.dataset.hash;
				const isSelected = targetResult.classList.contains('selected');

				if (isSelected) {
					targetResult.classList.remove('selected');
					targetResult.querySelector('.checkbox > .checkbox').checked = false;
					this.selectedHashes[index] = null;
				} else {
					targetResult.classList.add('selected');
					targetResult.querySelector('.checkbox > .checkbox').checked = true;
					this.selectedHashes[index] = hash;
				}

				fadeOut(qs('.timetable-wrapper', this.elems.timetableElement));

				// If only one other hash for each bound, add them all to the selected hashes
				const tableContainers = qsa('.table-container', this.elems.timetableElement).filter(container => container !== targetResult.closest('.table-container'));
				const onlyOneOption = tableContainers.every(container => qsa('.timetable-result', container).length === 1);
				if (onlyOneOption && !isSelected) {
					tableContainers.forEach((container) => {
						// Get index
						const index = getNodeIndex(container);
						// Get hash
						const hash = qs('.timetable-result', container).dataset.hash;
						// Add to selected hashes
						this.selectedHashes[index] = hash;
					});
				}

				this.update();

				return;
			}

			// Table sort
			const targetTableSort = target.closest('.timetable .abTabNav__btn--sorter');

			if (targetTableSort) {
				this.sortRows(targetTableSort);
				return;
			}

			// Expander click
			const targetExpander = target.closest('.table-container .top .expander');
			if (targetExpander) {
				targetExpander.closest('.table-container').querySelector('.timetable-result.selected')?.click?.();
			}
		});

		// Hide results if there was an error
		EventDispatcher.addEventListener('showresult:requestResultUpdateError', ({ target }) => {
			if (target === 'timetable') {
				this.hide();
			}
		});

		// Show/hide timetable based on showresult view changes
		EventDispatcher.addEventListener('displayDirector:display', ({ display }) => {
			if (display === 'timetable') {
				this.show();
				this.update();
			} else if (this.isActive) {
				this.hide();
			}
		});

		// Initiate result update request params on showresult demand
		EventDispatcher.addEventListener('showresult:requestResultUpdate', (data) => {
			if (!this.isActive || data.target !== 'timetable') {
				return;
			}
			this.update();
		});

		// Render new results when results have been updated from showresult (mostly due to filters update)
		EventDispatcher.addEventListener('showresult:resultsUpdated', (flights) => {
			if (!timetable.isActive) {
				return;
			}

			// fadeOut(this.elems.loadingSpinner);

			// Check if at least one flight entry of results is empty
			const missingResults = flights.some(flight => flight.length === 0);

			// Reset selection if results are missing
			if (missingResults) {
				this.clearHashes();
			}
			flights = flights.map(flight => resultsRender.getFlights(flight));

			// Render the view accordingly
			timetable.render(flights);

			if (timetable.isInitSortingSet) {
				return;
			}
			timetable.isInitSortingSet = true;
			qsa('.abTabNav__btn--sorter.field-departure').forEach((item) => {
				item.click();
			});
		});


		EventDispatcher.addEventListener('showresult:filtersReset', (activeView) => {
			if (!this.isActive || activeView !== 'timetable') {
				return;
			}
			this.clearHashes();
		});
	},

	setSorting (clickedItem) {
		const timetableElement = clickedItem.closest('.timetable');
		qsa('.timetable .abTabNav__btn--sorter', timetableElement)
			.filter(item => item !== clickedItem)
			.forEach((item) => {
				item.classList.remove('desc');
				item.classList.remove('asc');
				item.classList.remove('active');
			});

		let reverse = false;
		const isAsc = clickedItem.classList.contains('asc');
		const isDesc = clickedItem.classList.contains('desc');

		if (isAsc) {
			clickedItem.classList.remove('asc');
			clickedItem.classList.add('desc');
			reverse = true;
		} else if (isDesc) {
			clickedItem.classList.remove('desc');
			clickedItem.classList.add('asc');
		} else {
			clickedItem.classList.add('asc');
		}

		clickedItem.classList.add('active');

		let field = clickedItem.classList.value;
		field = field.substr(field.indexOf('field-') + 6);
		field = field.split(' ');
		field = field[0];

		const rows = qsa('.timetable-result', timetableElement);

		return { field, reverse, rows };
	},


	sortRows (clickedItem) {
		const { field, reverse, rows } = this.setSorting(clickedItem);
		if (!rows.length) {
			console.warn('timetable.sortRows: no rows to sort');
			return;
		}

		const parentContainer = rows[0].closest('.table-container');
		this.sorting[parentContainer.id] = { field, reverse };

		// Decide our sort‐fields: either ['departure','arrival'] or [field]
		const keys = field === 'compact'
			? ['departure', 'arrival']
			: [field];

		// Single helper: pull & cast one field off one row
		const getField = (el, key) => {
			const raw = el.querySelector(`.field-${key}`).dataset.field;
			return isNaN(+raw) ? raw : +raw;
		};

		// Sort by each key in order, stopping as soon as we find a difference
		rows.sort((a, b) => {
			for (const k of keys) {
				const va = getField(a, k);
				const vb = getField(b, k);
				if (va !== vb) {
					return typeof va === 'string'
						? va.localeCompare(vb)
						: va - vb;
				}
			}
			return 0;
		});

		if (reverse) {
			rows.reverse();
		}

		// Re-append into the DOM in one go
		const parent = rows[0].parentElement;
		const frag = document.createDocumentFragment();
		rows.forEach(r => frag.appendChild(r));
		parent.appendChild(frag);
	},

	getBounds (flights) {
		return range(0, js_params.trips_count - 1);
	},
	render (flightGroups) {
		// get active sorting
		// const activeSortingButtons = qsa('.abTabNav__btn--sorter.active', this.elems.timetableElement);
		fadeOut(qs('.timetable-wrapper', this.elems.timetableElement));

		const result = [];

		for (let i = 0; i < flightGroups.length; ++i) {
			const group = flightGroups[i];

			const data = timetable.getNboundData(group, i);

			result.push(data);
		}

		const wrapper = {
			bounds: result,
			isReturn: js_params.returntrip === 1,
			source: 'timetable',
			selectedHashes: this.selectedHashes
		};

		this.elems.timetableElement.innerHTML = renderTimetable(wrapper);

		// Draw selected result

		if (timetable.allHashesSet()) {
			const row = flightGroups[0][0];
			timetable.currentRow = row;

			resultsRender.response.flights = [row];

			resultsRender.render([row], 0, qs('#timetable-result', this.elems.timetableElement), 'timetable');
		}

		// Update selected

		timetable.selectedHashes.forEach(function (hash, i) {
			if (hash) {
				const container = qsa('#showresult-timetable .table-container')?.[i];

				if (!container) {
					return;
				}

				const elem = container.querySelector(`[data-hash='${hash}']`);

				if (elem) {
					elem.classList.add('selected');
					container.scrollTo({ top: elem.offsetTop, behavior: 'smooth' });
				}
			}
		});

		// sort
		this.elems.timetableElement.querySelectorAll('.sort.field-departure').forEach(item => item.click());

		Object.entries(this.sorting).forEach(([id, { field, reverse }]) => {
			const container = qs(`#${id}`, this.elems.timetableElement);
			if (!container) {
				console.warn(`timetable.render: no container found for id ${id}`);
				return;
			}
			const sortButton = container.querySelector(`.abTabNav__btn--sorter.field-${field}`);
			if (!sortButton) {
				console.warn(`timetable.render: no sort button found for field ${field} in container ${id}`);
				return;
			}
			this.sortRows(sortButton);
		});
	},
	getNboundData (group, index) {
		const result = [];

		for (let i = 0; i < group.length; ++i) {
			const flight = group[i];

			if (flight == 'undefined' || flight == null) {
				return;
			}

			const data = timetable.getRowData(flight, index);

			result.push(data);
		}

		return result;
	},
	getRowData (flight, index) {
		const alt = flight.trips[index];
		const lastSegment = last(alt.segments);

		const obj = {
			hash: alt.hash,
			price: flight.agents[0].price,
			traveltime: alt.traveltime,
			traveltimeText: getTimeText(alt.traveltime),
			segments: alt.segments,
			numStops: alt.segments.length - 1,
			departure: resultsRender.getAirport(alt.segments[0].departureAirport),
			departureIATA: alt.segments[0].departureAirport,
			departureTime: resultsRender.getDisplayTime(alt.segments[0].departureDate),
			departureDate: alt.segments[0].departureDate,
			arrival: resultsRender.getAirport(lastSegment.arrivalAirport),
			arrivalIATA: lastSegment.arrivalAirport,
			arrivalTime: resultsRender.getDisplayTime(lastSegment.arrivalDate),
			arrivalDate: lastSegment.arrivalDate,
			agent: flight.agents[0].agent,
			code: flight.agents[0].code
		};

		return obj;
	}
};

window.missingAgencyImg = timetable.missingAgencyImg;
window.timetable = timetable;


/**
 * @typedef {Object} Airport
 * @property {string} city
 * @property {string} airport
 *
 * @typedef {Object} Leg
 * @property {string} hash
 * @property {string} agent
 * @property {string} code
 * @property {string} compact
 * @property {string} departureTime
 * @property {string} arrivalTime
 * @property {string} departureIATA
 * @property {string} arrivalIATA
 * @property {Airport} departure
 * @property {Airport} arrival
 * @property {number} numStops
 * @property {number} traveltime          // in minutes
 * @property {string} traveltimeText      // e.g. “2 h 15 m”
 * @property {number} price
 */

/**
 * Build the timetable markup.
 *
 * @param {Object} params
 * @param {Leg[][]} params.bounds          - outer array = “out/return”, inner array = legs for that bound
 * @param {boolean} params.isReturn        - mirrors original {{#if @root.isReturn}}
 * @returns {string}                       - HTML string
 */
function renderTimetable ({ bounds, isReturn, selectedHashes }) {
	const renderHeader = () => `
	<div class="abTabNav abTabNav--timetableSorting">
	${[
		{ cls: 'agency', key: 'timetable.heading.travelAgency' },
		{ cls: 'compact', key: 'global.simplePhrases.trip' },
		{ cls: 'departure', key: 'timetable.heading.departure' },
		{ cls: 'arrival', key: 'timetable.heading.arrival' },
		{ cls: 'changes', key: 'showresult.filter.transfersTitle' },
		{ cls: 'journey-time', key: 'timetable.heading.travelDuration' },
		{ cls: 'price', key: 'timetable.heading.price' }
	]
		.map(
		({ cls, key }) => `
			<div class="abTabNav__btn abTabNav__btn--sorter field-${cls}">
			<span class="abTabNav__text">${l(key)}</span>
			</div>`
		)
		.join('')}
	</div>`;


	const renderHeaderRightColumn = function (index, trips, selectedHashes) {
		const aircraftIcon = (index === 0) ? 'icon-circle-plane-up' : 'icon-circle-plane-down';
		const text = (index === 0) ? l('showresult.timeTable.chooseOutwardJourney', 'Välj utresa') : l('showresult.timeTable.chooseJourneyHome', 'Välj hemresa');

		let html = `<i class="icon ${aircraftIcon}"></i><span class="top-text">${text}</span>`;

		if (selectedHashes[index]) {
			html += `
		<div class="abBtn abBtn-block abBtn--blueWhite expander">
			<span>${ l('showresult.timeTable.chooseAnotherTrip', 'Välj annan resa') }</span>
		</div>
	`;
		} else {
			html += `<span class="num-of-trips">${trips} ${ l('global.simplePhrases.trips') }</span>`;
		}

		return html;
	};


	const renderLeg = leg => `
	  <li class="timetable-result" data-hash="${leg.hash}">
		<label class="checkbox" tabindex="-1">
		  <input type="checkbox" value="1" tabindex="-1" aria-label="${leg.hash}" class="checkbox">
		  <div class="checkbox__tick">
			<div class="checkbox__tick--svg">
			  <!-- simplified SVG checkmark -->
			  <svg viewBox="0 0 24 24" width="16" height="16" stroke="#fff" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round">
				<polyline points="4 12 9 17 20 6"></polyline>
			  </svg>
			</div>
		  </div>
		</label>
  
		<div class="field field-agency" data-field="${leg.agent}">
		  <img src="${getAgencyImagePath({ code: leg.code })}" width="90" height="25"
			   class="agency-logo" title="${leg.agent}" alt="${leg.agent}">
		</div>
  
		<div class="field field-compact" data-field="${leg.compact}">
		  <span class="text time">${leg.departureTime}</span>
		  <span class="text airport">(${leg.departureIATA})</span>
		  &ndash;
		  <span class="text time">${leg.arrivalTime}</span>
		  <span class="text airport">(${leg.arrivalIATA})</span>
		</div>
  
		<div class="field field-departure" data-field="${leg.departureDate}">
		  <span class="text time">${leg.departureTime}</span>
		  <span class="text airport">${leg.departure.airport} (${leg.departureIATA}), ${leg.departure.city}</span>
		</div>
  
		<div class="field field-arrival" data-field="${leg.arrivalDate}">
		  <span class="text time">${leg.arrivalTime}</span>
		  <span class="text airport">${leg.arrival.airport} (${leg.arrivalIATA}), ${leg.arrival.city}</span>
		</div>
  
		<div class="field field-changes" data-field="${leg.numStops}">
		  <span class="text">${leg.numStops}</span>
		</div>
  
		<div class="field field-journey-time" data-field="${leg.traveltime}">
		  <span class="text time">${leg.traveltimeText}</span>
		</div>
  
		<div class="field field-price" data-field="${leg.price}">
		  <span class="text price">${lc(leg.price, true)}</span>
		</div>
	  </li>`;

	const renderBound = (legs, idx) => `
	  <div id="timetable-${idx}" class="table-container">
		<div class="top">
		  ${renderHeaderRightColumn(idx, legs.length, selectedHashes)}
		</div>
		<div class="timetable">
		  ${renderHeader()}
		  <div class="timetable-results-container${isReturn ? ' timetable-return' : ''}">
			<ul class="timetable-results">
			  ${legs.map(renderLeg).join('')}
			</ul>
		  </div>
		</div>
	  </div>`;

	return `
	  <div id="timetable-result"></div>
	  <div class="timetable-wrapper">
		${bounds.map(renderBound).join('')}
	  </div>
	`.trim();
}
